import UsersViewClient from '@/views/user/Users.vue'
import FormUserViewClient from '@/views/user/FormUser'

const collaboratorRouter = (beforeEnter) => {
    return [
        {
            beforeEnter: beforeEnter,
            name: 'Colaboradores',
            path: '/colaboradores',
            meta: {
                breadcrumb: true,
                breadcrumbName: 'Colaboradores',
                public: false,
                isEmployee: false,
                layout: 'default'
            },
            component: UsersViewClient
        },
        {
            beforeEnter: beforeEnter,
            name: 'CadastrarColaborador',
            path: '/colaboradores/cadastrar',
            meta: {
                requiresAuth: true,
                isEmployee: false,
                breadcrumb: true,
                breadcrumbName: 'Cadastrar Colaborador',
                layout: 'default'
            },
            component: FormUserViewClient
        },
        {
            beforeEnter: beforeEnter,
            name: 'EditarColaborador',
            breadcrumb: 'Editar Colaborador',
            path: '/colaboradores/editar/:id',
            meta: {
                requiresAuth: true,
                isEmployee: false,
                breadcrumb: true,
                breadcrumbName: 'Editar Colaborador',
                layout: 'default'
            },
            component: FormUserViewClient
        }
    ]
}

export default collaboratorRouter
